// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VEZX","type":"styles_type__KwBbg","choices":"styles_choices__2mgY-"};